

export default {
    state: {
        isCollapse: null
    },
    mutations: {
        setIsCollapse(state, data) {
            state.isCollapse = data;
        },
    },
    actions: {
        setIsCollapse({ commit}, data) {
            commit("setIsCollapse", data);
        }
    },
    getters: {
        getIsCollapse(state) {
            return state.isCollapse;
        }
    }
}
